interface FormFieldProps {
  id: string;
  label: React.ReactNode;
  error?: string;
  hint?: string;
  required?: boolean;
  children: React.ReactNode;
}

export function FormField({ id, label, error, hint, required, children }: FormFieldProps) {
  return (
    <div className="space-y-1">
      <label htmlFor={id} className="text-sm font-medium">
        {label}{required && <span className="text-error ml-0.5">*</span>}
      </label>
      {children}
      {hint && !error && (
        <p id={`hint-${id}`} className="text-xs text-text-secondary">{hint}</p>
      )}
      {error && (
        <p id={`error-${id}`} className="text-xs text-error" role="alert">{error}</p>
      )}
    </div>
  );
}
